import styles from '../../assets/styles/Components/ReceiptListItem.module.scss';
import { FaExpandAlt } from 'react-icons/fa';
import MimaText from '../MimaText';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
	service: PropTypes.string,
	quantity: PropTypes.number,
	amount: PropTypes.number,
	date: PropTypes.string,
};
const defaultProps = {
	service: 'Change Service',
	quantity: 1,
	amount: 15000000,
	date: 'DD/MM/YY',
};

const ReceiptListItem = ({ service, quantity, amount, date, ...props }) => {
	return (
		<div className={styles.rec}>
			<div>
				<MimaText variant="xsmall">Service</MimaText>
				<p className={styles.rec__main}>{service}</p>
			</div>
			<div>
				<MimaText variant="xsmall">Amount</MimaText>
				<p className={styles.rec__main}>{amount}</p>
			</div>
			<div>
				<MimaText variant="xsmall">QTY</MimaText>
				<p className={styles.rec__main}>{quantity}</p>
			</div>
			<div className={styles.rec__expand}>
				<FaExpandAlt />
			</div>
		</div>
	);
};

ReceiptListItem.propTypes = propTypes;

ReceiptListItem.defaultProps = defaultProps;

export default ReceiptListItem;
